import { combineReducers } from "redux";
import cargoDialog from "./cargo-dialog";
import scheduleCargoTemplateDialog from "./schedule-cargo-template-dialog";
import clientCargoTemplateDialog from "./client-cargo-template-dialog";
import fleetManagement from "./fleet-management";
import driverDialog from "./driver-dialog";
import trailerDialog from "./trailer-dialog";
import equipmentDialog from "./equipment-dialog";
import equipmentTypeDialog from "./equipment-type-dialog";
import equipmentDepotDialog from "./equipment-depot-dialog";
import rentalDialog from "./rental-dialog";
import fractionDialog from "./fraction-dialog";
import routeInfo from "./route-info";
import userSettings from "./userSettings";
import teamsDialog from "./teams-dialog";
import dispatching from "./dispatching";
import routes from "./routes";
import upcomingPage from "./upcoming-page";
import orderDialog from "./order-dialog";
import businessCentral from "./business-central";
import apiKeys from "./api-keys";
import undispatchedCargosCardsHover from "./undispatched-cargos-cards-hover";
import dispatchingViewResize from "./dispatching-view-resize";

export default combineReducers({
  cargoDialog,
  scheduleCargoTemplateDialog,
  clientCargoTemplateDialog,
  fleetManagement,
  driverDialog,
  trailerDialog,
  equipmentDialog,
  equipmentTypeDialog,
  equipmentDepotDialog,
  rentalDialog,
  fractionDialog,
  userSettings,
  routeInfo,
  teamsDialog,
  dispatching,
  routes,
  upcomingPage,
  orderDialog,
  businessCentral,
  apiKeys,
  undispatchedCargosCardsHover,
  dispatchingViewResize,
});
